import {
    Vector2,
    Vector3,
    Matrix4,
    Color,
    Euler,
    Path,
    Shape,
    ShapeUtils,
    DoubleSide,
    FrontSide,
    LinearFilter,
    RGBFormat,
    NoBlending,
    NormalBlending,
    UniformsUtils,
    ShaderLib,
    ShaderChunk,
    Uniform,
    BufferAttribute,
    Uint16BufferAttribute,
    Float32BufferAttribute,
    InterleavedBufferAttribute,
    InterleavedBuffer,
    BufferGeometry,
    PlaneBufferGeometry,
    CylinderBufferGeometry,
    TorusGeometry,
    SphereBufferGeometry,
    BoxBufferGeometry,
    ShapeGeometry,
    ExtrudeGeometry,
    Mesh,
    Points,
    Group,
    ShaderMaterial,
    MeshBasicMaterial,
    MeshMatcapMaterial,
    PointsMaterial,
    WebGL1Renderer,
    WebGLRenderer,
    Scene,
    Fog,
    PerspectiveCamera,
    VideoTexture,
    Texture,
    TextureLoader,
    ArcCurve,
    CatmullRomCurve3,
    CubicBezierCurve,
    CubicBezierCurve3,
    EllipseCurve,
    LineCurve,
    LineCurve3,
    QuadraticBezierCurve,
    QuadraticBezierCurve3,
    SplineCurve
} from 'three';

const Curves = {
    ArcCurve,
    CatmullRomCurve3,
    CubicBezierCurve,
    CubicBezierCurve3,
    EllipseCurve,
    LineCurve,
    LineCurve3,
    QuadraticBezierCurve,
    QuadraticBezierCurve3,
    SplineCurve
};

const THREE = {
    Vector2,
    Vector3,
    Matrix4,
    Color,
    Euler,
    Path,
    Shape,
    ShapeUtils,
    DoubleSide,
    FrontSide,
    LinearFilter,
    RGBFormat,
    NoBlending,
    NormalBlending,
    UniformsUtils,
    ShaderLib,
    ShaderChunk,
    Uniform,
    BufferAttribute,
    Uint16BufferAttribute,
    Float32BufferAttribute,
    InterleavedBufferAttribute,
    InterleavedBuffer,
    BufferGeometry,
    PlaneBufferGeometry,
    CylinderBufferGeometry,
    TorusGeometry,
    SphereBufferGeometry,
    BoxBufferGeometry,
    ShapeGeometry,
    ExtrudeGeometry,
    Mesh,
    Points,
    Group,
    ShaderMaterial,
    MeshBasicMaterial,
    MeshMatcapMaterial,
    PointsMaterial,
    WebGL1Renderer,
    WebGLRenderer,
    Scene,
    Fog,
    PerspectiveCamera,
    VideoTexture,
    Texture,
    TextureLoader,
    Curves
};

export default THREE;
